import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emailTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.email-title',
		defaultMessage: 'Email',
		description: 'Text used in email header',
	},
	emailDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.email-description',
		defaultMessage: `
            <p>
                Turn emails into support requests that are automatically added to your queues
                <a target="_blank" href="{href}">Learn more about email requests.</a>.
            </p>`,
		description:
			'Description that explains what email is. {href} contains the URL to the help article, it does not need translation',
	},
	emailDescriptionForInProductHelp: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.email-description-for-in-product-help',
		defaultMessage:
			'Turn emails into support requests that are automatically added to your queues. {learnMoreLink}',
		description:
			'Description that explains what email is. {learnMoreLink} will be replaced by a button, it does not need translation',
	},
	learnMoreAboutEmail: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.learn-more-about-email',
		defaultMessage: 'Learn more about email requests',
		description: 'Text used in email learn more link',
	},
	emailSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.email-success-title',
		defaultMessage: `Email turned {value, select,
            false {off}
            true {on}
            other {}
        }`,
		description: 'Title text of success flag',
	},
	successEnableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.success-enable-description',
		defaultMessage: 'View and customize your email address on the email page.',
		description: 'Body text of success flag when feature is enabled',
	},
	successDisableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.success-disable-description',
		defaultMessage: 'You can turn this on again at any time.',
		description: 'Body text of success flag when feature is disabled',
	},
	successEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.success-enable-action',
		defaultMessage: 'Go to email page',
		description: 'Label used in action button in success flag when feature is enabled',
	},
	successDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.email-features.success-disable-dismiss',
		defaultMessage: 'Ok',
		description: 'Label used in dismiss button in success flag when feature is disabled',
	},
});
